import styled from 'styled-components';


const TextFieldLayout = styled.div`
	position: relative;
	width: 100%;

	&::after {
		content: '';
		display: block;
		position: absolute;
		left: 0;
		width: calc(100% - 28px);
		height: 30px;
		background-color: transparent;
		transform: translate(0, -150%);
		cursor: pointer;
	}
`;

export {
	TextFieldLayout,
};
